import { graphql } from "@server/gql";

export const clearPromotionMutation = graphql(/* GraphQL */ `
  mutation clearPromotion($cartId: String!, $locale: String!) {
    cart: clearPromotionsFromCart(cartId: $cartId, locale: $locale) {
      ...cart
    }
  }
`);
